import React, { useEffect, useState } from 'react'
import {
    Stack,
    Box,
    Fab
} from '@mui/material'
import * as Texts from '../../components/UIComponents/Text'
import * as Images from '../../components/UIComponents/Images'
import DotIndicator from './DotIndicator'
import NavigationIcon from '@mui/icons-material/Navigation';

const LeftProgressPanel = ({
    history,
    selectedDot,
    setSelectedDot,
    dict
}) => {
    // console.log("received dict", dict)
    const pagesArr = [
        {
            title: dict["title0"],
            subtitle: dict["subtitle0"],
            image: <Images.UserProfile />
        },
        {
            title: dict["title1"],
            subtitle: dict["subtitle1"],
            image: <Images.DemoProfile />
        },
        {
            title: dict["title2"],
            subtitle: dict["subtitle2"],
            image: <Images.LifeDetails />
        },
        {
            title: dict["title3"],
            subtitle: dict["subtitle3"],
            image: <Images.HealthData />
        }
    ]
    // console.log(`the selected dot is `, selectedDot)
    return (<Stack
        direction={"column"}
        justifyContent={{
            xs: "center",
            lg: "flex-start"
        }}
        alignItems={"center"}
        spacing={5}
        sx={{
            // bgcolor: 'background.dark',
            width: 1,
            px: {
                xs: 4,
                sm: 6,
                md: 8
            },
            py: {
                xs: 4,
                sm: 6,
                md: 8
            }
        }}
    >
        <Texts.H4
            sx={{
                color: 'primary.dark'
            }}
        >{pagesArr[selectedDot]["title"]}</Texts.H4>
        <Texts.Tip>{pagesArr[selectedDot]["subtitle"]}</Texts.Tip>
        <Texts.SmallTip
            sx={{
                lineHeight: 1.4
            }}
        >{dict["safety"]}</Texts.SmallTip>
        <Box
            sx={{
                width: '240px',
                display: {
                    xs: 'none',
                    md: 'block'
                }
            }}
        >
            {pagesArr[selectedDot]["image"]}
        </Box>


        <Stack direction="row" spacing={2}>
            {pagesArr.map((_, index) => (
                <Fab
                    key={index}
                    variant="extended"
                    disableRipple
                    size={index === selectedDot ? "medium" : "small"}
                    color={index === selectedDot ? "primary" : "default"}
                    onClick={() => setSelectedDot(index)}
                    sx={{
                        typography: 'body4',
                        textTransform: 'none',
                        fontSize: {
                            xs: '0.9rem',
                            sm: '1rem',
                        },
                        padding: {
                            xs: '0.4em 0.4em',
                            sm: '0.5em 0.5em',
                        },
                        height: 'auto', 
                        width: 'auto',
                        minWidth: '4em', 
                        alignItems: 'center',
                        // flexDirection: 'column',
                    }}
                >
                    {/* <NavigationIcon sx={{ fontSize: '0.8em', mb: 0.5 }} /> */}
                    {dict[`dot${index}`] || `Step ${index + 1}`}
                </Fab>
            ))}
        </Stack>

    </Stack>)
}

export default LeftProgressPanel